import React from "react";
import { Table, Divider } from "antd";
import {
  ConformityLevel,
  ImportExportOption,
  Step2VM,
} from "../../autogenerated/models";

interface SelectionsSummaryProps {
  choices: Step2VM;
}

const SelectionsSummary: React.FC<SelectionsSummaryProps> = ({
  choices = {},
}) => {
  const profileColumns = [
    { title: "Profile", dataIndex: "profileName", key: "profileName" },
    {
      title: "Inclusive",
      children: [
        {
          title: "Import",
          dataIndex: "inclusiveImportOption",
          key: "inclusiveImportOption",
          render: (record: ImportExportOption) => (
            <>{ImportExportOption[record].replace("_", " ")} </>
          ),
        },
        {
          title: "Export",
          dataIndex: "inclusiveExportOption",
          key: "inclusiveExportOption",
          render: (record: ImportExportOption) => (
            <>{ImportExportOption[record].replace("_", " ")} </>
          ),
        },
      ],
    },
    {
      title: "Individual",
      children: [
        {
          title: "Import",
          dataIndex: "individualImportOption",
          key: "individualImportOption",
          render: (record: ImportExportOption) => (
            <>{ImportExportOption[record].replace("_", " ")} </>
          ),
        },
        {
          title: "Export",
          dataIndex: "individualExportOption",
          key: "individualExportOption",
          render: (record: ImportExportOption) => (
            <>{ImportExportOption[record].replace("_", " ")} </>
          ),
        },
      ],
    },
    {
      title: "Difference",
      children: [
        {
          title: "Import",
          dataIndex: "differenceImportOption",
          key: "differenceImportOption",
          render: (record: ImportExportOption) => (
            <>{ImportExportOption[record].replace("_", " ")} </>
          ),
        },
        {
          title: "Export",
          dataIndex: "differenceExportOption",
          key: "differenceExportOption",
          render: (record: ImportExportOption) => (
            <>{ImportExportOption[record].replace("_", " ")} </>
          ),
        },
      ],
    },
  ];

  const functionColumns = [
    { title: "Function", dataIndex: "functionName", key: "functionName" },
    {
      title: "Conformity level",
      dataIndex: "option",
      key: "option",
      render: (record: ConformityLevel) => <>{ConformityLevel[record]} </>,
    },
  ];

  return (
    <>
      <Table
        columns={profileColumns}
        dataSource={choices.selectedProfileOptions}
        pagination={false}
        size="small"
        rowKey={(record) => record.profileId ?? ""}
      />
      <Divider></Divider>
      <Table
        columns={functionColumns}
        dataSource={choices.selectedFunctionOptions}
        pagination={false}
        size="small"
        rowKey={(record) => record.functionId ?? ""}
      />
    </>
  );
};

export default SelectionsSummary;
